import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

// Use initializeFirestore (not getFirestore) so we can set transport options.
// experimentalAutoDetectLongPolling makes the SDK fall back to long-polling
// when the WebChannel streaming transport gets blocked by a proxy / firewall /
// ad-blocker / mobile carrier. This eliminates the recurring
//   "Failed to load resource: net::ERR_TIMED_OUT"
// on /Listen/channel and /Write/channel that Lighthouse reports.
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});

const storage = getStorage(app);

// Analytics is loaded lazily so it never sits on the LCP critical path and
// never throws on browsers / regions where measurement-protocol endpoints fail.
let analyticsPromise = null;
const getAnalyticsLazy = () => {
  if (analyticsPromise) return analyticsPromise;
  if (typeof window === "undefined") return Promise.resolve(null);
  analyticsPromise = import("firebase/analytics")
    .then(({ isSupported, getAnalytics }) =>
      isSupported().then((ok) => (ok ? getAnalytics(app) : null))
    )
    .catch(() => null);
  return analyticsPromise;
};

export { app, db, storage, getAnalyticsLazy };
